import React, { useState } from 'react';
import Table from 'cccisd-graphql-table';
import Loader from 'cccisd-loader';
import Modal from 'cccisd-modal';

import tableQuery from './jobTable.graphql';
import style from './style.css';
import { JobStatus, ModalView, Runtime } from '../devopsRenders.js';
import ContainerSearch from './ContainerSearch';
import ParameterSearch from './ParameterSearch';

const JobTable = props => {
    const [isLoading, setIsLoading] = useState(false);

    const columns = [
        { name: 'jobId', label: 'ID', sort: true, filter: true },
        { name: 'label', label: 'Job', sort: true, filter: true },
        { name: 'consoleOutput', label: 'Console Output', sort: true, filter: true, render: ModalView },
        { name: 'status', label: 'Status', sort: true, filter: true, render: JobStatus },
        { name: 'initiator.username', label: 'Run By', sort: true, filter: true },
        { name: 'runtime', label: 'Runtime', sort: true, filter: true, render: Runtime },
        { name: 'queuedAt', label: 'Queued', sort: true, filter: true },
        { name: 'completedAt', label: 'Completed', sort: true, filter: true },
    ];

    const forceUpdate = async () => {
        setIsLoading(true);
        setIsLoading(false);
    };

    return (
        <Loader loading={isLoading} removeChildren>
            {!isLoading && (
                <div>
                    <div className={style.launchbutton}>
                        <Modal
                            trigger={
                                <button className={style.button + ' btn btn-primary'} type="button">
                                    Container Search
                                </button>
                            }
                            title="Container Search"
                            headerStyle={{
                                backgroundColor: '#007298',
                                color: '#fff',
                            }}
                            formAutoFocus
                            afterClose={() => forceUpdate()}
                            render={({ closeModal }) => <ContainerSearch closeModal={closeModal} />}
                        />
                        <Modal
                            trigger={
                                <button className={style.button + ' btn btn-primary'} type="button">
                                    Parameter Search
                                </button>
                            }
                            title="Parameter Search"
                            headerStyle={{
                                backgroundColor: '#007298',
                                color: '#fff',
                            }}
                            formAutoFocus
                            afterClose={() => forceUpdate()}
                            render={({ closeModal }) => <ParameterSearch closeModal={closeModal} />}
                        />
                    </div>
                    <Table
                        query={tableQuery}
                        rowKey="jobId"
                        orderBy="jobId"
                        isAscentOrder={false}
                        columns={columns}
                        renders={{
                            JobStatus,
                            ModalView,
                        }}
                        columnRenderParams={{
                            consoleOutput: { title: 'Console Output', buttontext: 'Console' },
                        }}
                    />
                </div>
            )}
        </Loader>
    );
};

export default JobTable;
